export * from './scrollTo.module';
export * from './scrollTo.service';
export * from './scrollTo.directive';
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// E:/SafeCloud-FrontEnd/WebConsorcioPimentel/node_modules/ng2-scroll-to-el/index.js
// module id = ../../../../ng2-scroll-to-el/index.js
// module chunks = vendor